import { Tooltip } from 'antd';
import React from 'react';

type Props = {
    children: React.ReactNode;
    width?: string;
    className?: string;
    onClick?: () => void;
    selected?: boolean;
    style?: React.CSSProperties;
    tooltip?: React.ReactNode;
};

const OnboardingCard: React.FC<Props> = ({ children, width, onClick, className, selected, style, tooltip }) => {
    const widthClass = width ? `${width}` : 'w-full';
    const styles = selected
        ? { border: `2px solid #142C53`, boxShadow: 'none' }
        : { boxShadow: `5px 5px 10px 0px #0000001A` };
    return (
        <>
            <Tooltip title={tooltip} placement="bottom">
                <div
                    onClick={onClick}
                    style={{ ...styles, ...style }}
                    className={`${widthClass} ${
                        className || ''
                    } flex cursor-pointer items-center p-4 bg-white text-sm text-color-404040 mb-6 border-2 border-white font-[Lato]`}
                >
                    {children}
                </div>
            </Tooltip>
        </>
    );
};

export default OnboardingCard;
